module.exports = __webpack_public_path__ + "img/img_display_3.11926ff4.svg";